var React = require('react');

function IconDRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 8L6 12V4L10 8Z","fill":"white"}));
}

IconDRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconDRight;

IconDRight.default = IconDRight;
